import {handleActions, createAction} from 'redux-actions';
import {ACTION_STATUS_PENDING} from 'utils/redux/thunkActionConstants';
import {createThunkActionCreator} from 'utils/redux/createThunkActionCreator';
import * as purchasesApi from 'services/api/purchases';
import * as constants from './constants';

const reducerMap = {};

export const payNowResetAction = createAction(constants.PAY_NOW_ACTION_RESET);
reducerMap[constants.PAY_NOW_ACTION_RESET] = (state, action) => {
  return {
    ...action
  };
};

export const payNowResetFailureAction = createAction(constants.PAY_NOW_ACTION_RESET_FAILURE);
reducerMap[constants.PAY_NOW_ACTION_RESET_FAILURE] = (state, action) => {
  return {
    ...state, status: null, ...action
  };
};

export const payNowAction = createThunkActionCreator(constants.PAY_NOW_ACTION_PURCHASE, (externalId, amount, applyAmountToNextPayments, debitCardDetails) => {
  return purchasesApi.applyUnscheduledPayment(externalId, amount, applyAmountToNextPayments, debitCardDetails);
});
reducerMap[constants.PAY_NOW_ACTION_PURCHASE] = (state, action) => {
  const {payload, ...rest} = action;
  return {
    ...state, ...rest, payments: payload
  };
};

export function simulateUnscheduledPaymentPendingAction() {
  return {
    type: constants.PAY_NOW_ACTION_SIMULATE_UNSCHEDULED_PAYMENT,
    status: ACTION_STATUS_PENDING,
    payload: null
  };
}

let simulateUnscheduledPaymentCount = 0
export const simulateUnscheduledPaymentAction = createThunkActionCreator(constants.PAY_NOW_ACTION_SIMULATE_UNSCHEDULED_PAYMENT, (externalId, amount, applyAmountToNextPayments) => {
  simulateUnscheduledPaymentCount++
  return purchasesApi.simulateUnscheduledPayment(externalId, amount, applyAmountToNextPayments, simulateUnscheduledPaymentCount);
});
reducerMap[constants.PAY_NOW_ACTION_SIMULATE_UNSCHEDULED_PAYMENT] = (state, action) => {
  const {payload, ...rest} = action;
  
  if (payload && payload.requestCounter < simulateUnscheduledPaymentCount) {
    return state
  }

  return {
    ...state, ...rest, simulatedPayments: payload && payload.data
  };
};


export const reducer = handleActions(reducerMap, {});



// WEBPACK FOOTER //
// ./src/pay-now/redux.js